import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";

function EditDoc() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState();
  const [, setDescription] = useState();
  const [userId, setUserId] = useState();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const {t} = useTranslation();


  useEffect(() => {
    axios
      .get(`${API_URL}/${API_VERSION}/users/doc/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setName(response.data.name);
        setDescription(response.data.description);
        setUserId(response.data.user);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  }, [id, API_URL, API_VERSION]);

  function updateFile() {
    // let user=id;
    axios
      .patch(
        `${API_URL}/${API_VERSION}/users/doc/${id}`,
        {
          name,
         user:"65b3841e1f11a6c828758b71"
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        navigate(`/admin/doc-list/${userId}`);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  }

  return (
    <>
      <section className="client_main">
        <Container>
          <Row className="justify-content-center">
            <Col xxl={6} xl={6} lg={6} md={8} sm={10}>
              <div className="boxwrap">
                <h1>{t("Update document")}</h1>
                <div className="form-group mb-3">
                  <label htmlFor="">{t("Title")}</label>                  
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </div>
                <div className="text-start mb-4">
                  <input
                    type="button"
                    value="Update"
                    className="button px-4 py-3"
                    onClick={() => updateFile()}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default EditDoc;
